export default __webpack_public_path__ + "static/media/image.coderay-technologies.7797ee2f.png";